// test1628
(1628 && 0);
